/**
 * HERO-IDs aus Fliesstext entfernen.
 *
 * Regel des Hauses: HERO-Bezeichnungen statt Nummern, nie eine nackte ID.
 * Der Planer schreibt trotzdem gern „Bestandskunde Christian Probeweber
 * (id=7621476)“ in sein Reasoning (Screenshot Marlene, 08.09.2026) — der Prompt
 * verbietet es inzwischen, aber gespeicherte Plaene tragen es weiter, und ein
 * Modell haelt sich nicht immer an Verbote. Hier faellt es beim Anzeigen weg.
 */
export function ohneIds(text: string | null | undefined): string {
  if (!text) return ""
  return text
    // „(id=7621476)“, „(ID: 7621476)“, „(id 7621476)“
    .replace(/\s*\(\s*id\s*[=:#]?\s*\d{3,}\s*\)/gi, "")
    // „id=7621476“ mitten im Satz
    .replace(/\s*\bid\s*=\s*\d{3,}\b/gi, "")
    // „#7621476“ — HERO-Vorgangsnummern sehen anders aus (SAN-534), sechs
    // und mehr Ziffern hinter einer Raute sind immer eine interne ID.
    .replace(/\s*#\d{6,}\b/g, "")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+([.,;:!?])/g, "$1")
    .trim()
}
